export default {
    fileStorage: {
        table: {
            StorageCode: 'Storage Code',
            policy: 'Filename Prefix Strategy',
            DomainName: 'Domain Name',
            control: 'Bucket Access Control',
            bucket: 'Bucket Prefix',
            Default: 'Default',
            Created: 'Created By',
            CreationTime: 'Creation Date',
        },
        dialog: {
            StorageCode: 'Storage Code',
            policy: 'Filename Prefix Strategy',
            DomainName: 'Domain Name',
            RegionBucket: 'Bucket Region',
            controlBucket: 'Bucket Access Control',
            bucketPrefix: 'Bucket Prefix',
            AutomaticallyBucket: 'Auto-create bucket',
            Default: 'Default',
            EditConfiguration: 'Edit Storage Configuration',
            CreateConfiguration: 'Create new storage configuration',
        },
        common: {
            StorageType: 'Storage Type',
            Tenant: 'Tenant',
        }
    },
};
